import React, { useState } from "react";
import ModalReserveMobile from "./ModalReserveMobile";
import ModalMobileOrder from "./ModalMobileOrder";
import converSelectedDateToString from "utils/converSelectedDateToString";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import NcInputNumber from "./NcInputNumber";

const MobileFooterSticky = ({
	id,
	info,
	
}: any) => {
	const [startDate] = useState<Date | null>(new Date("2023/02/06"));
	const [endDate] = useState<Date | null>(new Date("2023/02/23"));
	const [guestAdultsInputValue, setGuestAdultsInputValue] = useState(1);
	const [orderAmount, setOrderAmount] = useState(info.price * guestAdultsInputValue);

	const [reserveOpenModal, setReserveOpenModal] = useState(false);
	


	console.log("r1 asdhfjsdahf ??? ", info);

	return (
		<div className="block fixed bottom-0 inset-x-0 py-2 sm:py-3 bg-white dark:bg-neutral-800 border-t border-neutral-200 dark:border-neutral-6000 z-40">
			<div className="container flex items-center justify-between lg:w-[768px]">
				<div className="">
					<span className="block text-xl font-semibold">
						{Number(info.price).toLocaleString('ko-KR')}
						<span className="ml-1 text-sm font-normal text-neutral-500 dark:text-neutral-400">
							원
						</span>
					</span>
				</div>
				{/* <ModalReserveMobile
					renderChildren={({ openModal }) => (
					<ButtonPrimary
						sizeClass="px-5 sm:px-7 py-3 !rounded-2xl"
						onClick={openModal}
					>
						예약
					</ButtonPrimary>
					)}
				/>
				 */}
				{/* <ButtonPrimary
					sizeClass="px-5 sm:px-7 py-3 !rounded-2xl"
					onClick={handleOpenModal}
				>
						예약
				</ButtonPrimary> */}
				
					<ModalMobileOrder
						id={id}
						info={info}
					/>
				
				
			</div>
		</div>
	);
};

export default MobileFooterSticky;
